import { create } from 'zustand';

export interface IncidentInfo {
  outageMessage?: string;
  affectedProviders?: string[];
}

interface IncidentStore {
  hasActiveIncident: boolean;
  incidentInfo: IncidentInfo[] | null;
  isLoading: boolean;
  error: string | null;
  setIncidentInfo: (info: IncidentInfo[] | null) => void;
  setLoading: (loading: boolean) => void;
}

export const useIncidentStore = create<IncidentStore>((set) => ({
  hasActiveIncident: false,
  incidentInfo: null,
  isLoading: false,
  error: null,

  setIncidentInfo: (incidentInfo) =>
    set({
      incidentInfo,
      hasActiveIncident: (incidentInfo?.length || 0) > 0,
      error: null,
    }),
  setLoading: (loading) => set({ isLoading: loading }),
}));
